// extracted by mini-css-extract-plugin
export var barContainer = "_2z-0";
export var extraThin = "_2z-3";
export var fillBar = "_2z-6";
export var fillContainer = "_2z-4";
export var overflow = "_2z-8";
export var overflowContainer = "_2z-5";
export var regular = "_2z-7";
export var thick = "_2z-1";
export var thin = "_2z-2";